import { render } from "./TypePrompt.vue?vue&type=template&id=6a63734e&scoped=true"
import script from "./TypePrompt.vue?vue&type=script&lang=js"
export * from "./TypePrompt.vue?vue&type=script&lang=js"

import "./TypePrompt.vue?vue&type=style&index=0&id=6a63734e&scoped=true&lang=css"

import exportComponent from "/Users/joecortinhas/Documents/code/DigitalLaborSolutions/dlstracker_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a63734e"]])

export default __exports__